import { Screen } from '~/screens/Admins';

export const Admins: React.FC = () => {
  return <Screen />;
};
